import { withAuthenticationRequired } from '@auth0/auth0-react';
import { FunctionComponent } from 'react';
import { PageLoader } from './PageLoader';

interface ProtectedRouteProps {
  component: FunctionComponent;
}

export const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="page-layout">
        <PageLoader />
      </div>
    )
  });

  return <Component />;
};
